export function parseError(err: any, defaultMessage?: string): string {
  if (!err) {
    return 'Unknown error';
  }

  if (!err.message) {
    return `${err}`;
  }

  try {
    const parsed = JSON.parse(err.message);
    let message: string = parsed.message;
    if (message) {
      const { errors } = parsed;
      if (Array.isArray(errors)) {
        message = message + '\n' + errors.map((e: any) => String(e)).join('\n');
      } else if (errors && typeof errors === 'object' && 'data' in errors) {
        message = message + '\n' + parseZodFormattedError(errors.data).join('\n');
      }
      return message;
    }
  } catch {
    // ignore
  }
  return defaultMessage || `${err.message}`;
}

function parseZodFormattedError(error: Record<string, unknown>) {
  const messages: string[] = [];

  function traverse(part: unknown) {
    if (!part || typeof part !== 'object') {
      return;
    }

    const obj = part as Record<string, unknown>;
    if ('_errors' in obj && Array.isArray(obj._errors)) {
      messages.push(...obj._errors);
    }

    for (const key of Object.keys(obj)) {
      traverse(obj[key]);
    }
  }

  traverse(error);
  return messages;
}
